const initialState = {
    columns: [],
    records: [],
    tableName: '',
    columnDefinitions: [],
    contextMenuItems: [],
    sourceFieldSettings: {
        active: 'Y',
        deleted_ind: '1',
        manual_edits_allowed: 'N',
        manual_items_allowed: 'N',
        mc_manual_actions: 'N',
        updates_allowed: 'N',
    },
    apiLoggers: [],
    dashboardData: [],
    filesPendingApproval: [],
    recordsForAuth: []
};


export default initialState;

